(() => {
  // app/scripts/search-filters.js
  (() => {
    var PriceRange = class extends HTMLElement {
      constructor() {
        super();
        this.inputs = this.querySelectorAll('input[type="number"]');
        this.ranges = this.querySelectorAll('input[type="range"]');
        this.rangeTrack = this.querySelector(".jsRangeTrack");
        this.minInput = this.inputs[0];
        this.maxInput = this.inputs[1];
        this.minRange = this.ranges[0];
        this.maxRange = this.ranges[1];
        this.defaultMaxRange = Number(this.maxRange.getAttribute("max"));
        this.inputs.forEach(
          (element) => element.addEventListener("input", this.onInputChange.bind(this))
        );
        this.ranges.forEach(
          (element) => element.addEventListener("input", this.onRangeChange.bind(this))
        );
        this.updateUI();
      }
      onInputChange(event) {
        this.adjustToValidValues(event.currentTarget);
        this.syncInputsToRanges();
        this.updateUI();
      }
      onRangeChange() {
        this.syncRangesToInputs();
        this.updateUI();
      }
      syncInputsToRanges() {
        let min = Number(this.minInput.value || 0);
        let max = Number(this.maxInput.value || this.defaultMaxRange);
        if (min > max) {
          [min, max] = [max, min];
        }
        this.minRange.value = min;
        this.maxRange.value = max;
        this.maxInput.setAttribute("min", min);
        this.minInput.setAttribute("max", max);
      }
      syncRangesToInputs() {
        let min = Number(this.minRange.value);
        let max = Number(this.maxRange.value);
        if (min > max) {
          [min, max] = [max, min];
        }
        this.minInput.value = min;
        this.maxInput.value = max;
        this.maxInput.setAttribute("min", min);
        this.minInput.setAttribute("max", max);
      }
      updateUI() {
        const min = Number(this.minRange.value);
        const max = Number(this.maxRange.value);
        const percentMin = min / this.defaultMaxRange * 100;
        const percentMax = max / this.defaultMaxRange * 100;
        this.rangeTrack.style.left = percentMin + "%";
        this.rangeTrack.style.width = percentMax - percentMin + "%";
      }
      set([min, max]) {
        min = Number(min);
        max = Number(max);
        this.minInput.value = min;
        this.maxInput.value = max;
        this.minRange.value = min;
        this.maxRange.value = max;
        this.updateUI();
      }
      reset() {
        this.minInput.value = 0;
        this.maxInput.value = this.defaultMaxRange;
        this.minRange.value = 0;
        this.maxRange.value = this.defaultMaxRange;
        this.updateUI();
      }
      adjustToValidValues(input) {
        let value = Number(input.value);
        const min = Number(input.getAttribute("min") || 0);
        const max = Number(input.getAttribute("max") || this.defaultMaxRange);
        if (value < min)
          value = min;
        if (value > max)
          value = max;
        input.value = value;
      }
    };
    customElements.define("price-range", PriceRange);
    var customElementTagName = "filter-component";
    !window.customElements.get(customElementTagName) && window.customElements.define(customElementTagName, class extends HTMLElement {
      constructor() {
        super();
        this.addEventListener("input", this.onInput.bind(this));
        this.addEventListener("click", this.onClick.bind(this));
        this.pagination = document.querySelector("pagination-component");
        this.listenPagination();
      }
      onClick(e) {
        const { target } = e;
        if (target.closest(".toggle-ymm-filter")) {
          this.classList.toggle("filter-showing");
        }
        if (target.closest(".jsActiveFilters")) {
          this.removeField(target);
        }
        if (target.closest(".reset-filter")) {
          this.resetField();
        }
      }
      onInput(e) {
        if (this.debounce != null)
          clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
          this.filter();
          this.debounce = null;
        }, 300);
      }
      async filter() {
        const searchResult = document.querySelector(".jsSearchResult");
        const noResult = document.querySelector(".jsNoResult");
        if (searchResult) {
          searchResult.innerHTML = "";
        }
        if (noResult) {
          noResult.innerHTML = "";
        }
        const form = this.querySelector("form");
        const formData = new FormData(form);
        formData.append("section_id", this.dataset.sectionId);
        let searchParams = new URLSearchParams(formData);
        let result = await fetch(`${form.action}?${searchParams}`);
        result = await result.text();
        const div = document.createElement("div");
        div.innerHTML = result;
        div.querySelectorAll(".jsFilterUpdate").forEach((item) => {
          this.renderParts(item);
        });
        formData.delete("section_id");
        searchParams = new URLSearchParams(formData);
        window.history.replaceState({}, "", `${form.action}?${searchParams}`);
      }
      renderParts(newDiv) {
        const currentTarget = document.querySelector(`[class*="${newDiv.className}"]`);
        if (!currentTarget)
          return;
        currentTarget.replaceWith(newDiv);
        if (newDiv.classList.contains("pagination-container")) {
          this.pagination = document.querySelector("pagination-component");
          this.listenPagination();
        }
      }
      async listenPagination() {
        if (!this.pagination)
          return;
        await customElements.whenDefined("pagination-component");
        this.pagination.onChange((newPage) => {
          this.filterWithPage(newPage);
        });
      }
      async filterWithPage(page) {
        const searchResult = document.querySelector(".jsSearchResult");
        const noResult = document.querySelector(".jsNoResult");
        if (searchResult) {
          searchResult.innerHTML = "";
        }
        if (noResult) {
          noResult.innerHTML = "";
        }
        const form = this.querySelector("form");
        const formData = new FormData(form);
        formData.append("section_id", this.dataset.sectionId);
        if (page) {
          formData.append("page", page);
        }
        let searchParams = new URLSearchParams(formData);
        let result = await fetch(`${form.action}?${searchParams}`);
        result = await result.text();
        const div = document.createElement("div");
        div.innerHTML = result;
        div.querySelectorAll(".jsFilterUpdate").forEach((item) => {
          this.renderParts(item);
        });
        formData.delete("section_id");
        searchParams = new URLSearchParams(formData);
        window.history.replaceState({}, "", `${form.action}?${searchParams}`);
        const shopifySection = this.closest('[id^="shopify-section-"]');
        const scrollTarget = shopifySection || document.querySelector("#main-collection");
        if (scrollTarget) {
          scrollTarget.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
      removeField(e) {
        e.classList.add("hidden");
        const currentTarget = this.querySelector(`input[name='${e.getAttribute("data-name")}'][value='${e.getAttribute("data-value")}']`);
        if (!currentTarget)
          return;
        if (currentTarget.checked) {
          currentTarget.checked = false;
          this.filter();
        }
      }
      resetField() {
        this.querySelectorAll(".filter-group input:checked")?.forEach((item) => {
          item.checked = false;
        });
        this.querySelector(".jsActiveFilters").innerHTML = "";
        this.querySelector("price-range").reset();
        this.filter();
      }
    });
  })();
})();
